import { render, staticRenderFns } from "./testcases.vue?vue&type=template&id=223494ff&"
import script from "./testcases.ts?vue&type=script&lang=js&"
export * from "./testcases.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports